module.exports = __webpack_public_path__ + "img/print-maker-640.844419f9.jpg";